import { put, select, takeLatest } from 'redux-saga/effects'
import { clearValidationErrorsByPathList } from '../../../utilities/runRulesValidation.util'
import { getRulesSelector } from '../../rules/selectors'
import { IRulesState } from '../../rules/store/rules.types'
import { getPickupAddressSelector } from '../selectors'
import {
  setAddressLine1,
  setAddressLine2,
  setAptSuiteRoom,
  setCensusTract,
  setCity,
  setCommonAddress,
  setCountry,
  setCounty,
  setCrossStreetDirections,
  setHospitalUnit,
  setLocation,
  setMilePostMajorRoadway,
  setModeDescriptors,
  setPickupAddressModeDescriptorsPNNV,
  setOtherType,
  setReferringGPSE,
  setReferringGPSN,
  setReferringMD,
  setReferringMdOther,
  setReferringRN,
  setReferringUSNG,
  setResponseMode,
  setRFT,
  setSceneGrid,
  setState,
  setStateIds,
  setZip,
} from '../store/pickupAddress.actions'
import { PickupAddressConstants } from '../store/pickupAddress.constants'
import { IPickupAddressState } from '../store/pickupAddress.types'

export function* pickupAddressTypeChange() {
  const rules: IRulesState = yield select(getRulesSelector)
  const pickupAddress: IPickupAddressState = yield select(getPickupAddressSelector)
  const {
    otherType,
    location,
    commonAddress,
    addressLine1,
    addressLine2,
    aptSuiteRoom,
    milePostMajorRoadway,
    crossStreetDirections,
    city,
    state,
    county,
    zip,
    country,
    censusTract,
    referringMD,
    referringRN,
    sceneGrid,
    referringGPSE,
    referringGPSN,
    referringUSNG,
    responseMode,
    modeDescriptors,
    modeDescriptorsPNNV,
    hospitalUnit,
    referringMdOther,
    RFT,
    stateIds,
  } = pickupAddress

  if (otherType) {
    yield put(setOtherType(null))
  }
  if (location) {
    yield put(setLocation(''))
  }
  if (addressLine1) {
    yield put(setAddressLine1(''))
  }
  if (addressLine2) {
    yield put(setAddressLine2(''))
  }
  if (aptSuiteRoom) {
    yield put(setAptSuiteRoom(''))
  }
  if (milePostMajorRoadway) {
    yield put(setMilePostMajorRoadway(''))
  }
  if (crossStreetDirections) {
    yield put(setCrossStreetDirections(''))
  }
  if (city) {
    yield put(setCity(null))
  }
  if (state) {
    yield put(setState(null))
  }
  if (county) {
    yield put(setCounty(null))
  }
  if (zip) {
    yield put(setZip(''))
  }
  if (country) {
    yield put(setCountry(null))
  }
  if (censusTract) {
    yield put(setCensusTract(''))
  }
  if (referringMD) {
    yield put(setReferringMD(''))
  }
  if (referringRN) {
    yield put(setReferringRN(''))
  }
  if (sceneGrid) {
    yield put(setSceneGrid(null))
  }
  if (referringGPSN) {
    yield put(setReferringGPSN(''))
  }
  if (referringGPSE) {
    yield put(setReferringGPSE(''))
  }
  if (referringUSNG) {
    yield put(setReferringUSNG(''))
  }
  if (responseMode) {
    yield put(setResponseMode(null))
  }
  if (modeDescriptors && modeDescriptors.length) {
    yield put(setModeDescriptors([]))
  }
  if (modeDescriptorsPNNV) {
    yield put(setPickupAddressModeDescriptorsPNNV(null))
  }
  if (hospitalUnit) {
    yield put(setHospitalUnit(null))
  }
  if (referringMdOther) {
    yield put(setReferringMdOther(''))
  }
  if (RFT) {
    yield put(setRFT(''))
  }
  rules.errors = clearValidationErrorsByPathList(rules.errors, ['pickupAddress'])
  if (commonAddress) {
    yield put(setCommonAddress(null))
  }
  if (stateIds) {
    yield put(setStateIds(null))
  }
}

export function* pickupAddressTypeChangeSaga() {
  yield takeLatest([PickupAddressConstants.SET_TYPE], pickupAddressTypeChange)
}
